import { api } from "@/core/api/";

export default {
    getApplications(properties) {
        return api.get("api/tickets/applications", {
            params: {
                ...properties
            }
        });
    },
    getAssigned(properties) {
        return api.get("api/tickets/assigned", {
            params: {
                ...properties
            }
        });
    },
    getStatuses(properties) {
        return api.get("api/tickets/statuses", {
            params: {
                ...properties
            }
        });
    },
    getCaseTypes(properties) {
        return api.get("api/tickets/caseTypes", {
            params: {
                ...properties
            }
        });
    },
    getReceiptMedias(properties) {
        return api.get("api/tickets/receiptMedias", {
            params: {
                ...properties
            }
        });
    },
    getDepts() {
        return api.get("api/tickets/dept");
    },
    getTechnicalAsistanceInitfilter() {
        return api.get("api/tickets/technicalasistance/initfilter");
    },
}